import React from 'react';
import PropTypes from 'prop-types';
import { FDImage } from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';

export const ImageRel = ({
  relationship, width, height, rounded, objectFit, fullScreenExpansionIconColor,
}) => {
  // The relationship could have been missing, in which case we shouldn't render an image
  if (!relationship) {
    return null;
  }
  const aspectRatio = relationship.meta('aspectRatio');
  const altText = relationship.meta('altText') ?? ''; // If alt text is missing, FD will blow up - use an empty string as in that case
  const url = relationship.link('related').url();

  return (
    <FDImage objectFit={objectFit} alt={altText} src={url} width={width} height={height} rounded={rounded} aspectRatio={aspectRatio} {...dataAttrs('image-rel')} fullScreenExpansionIconColor={fullScreenExpansionIconColor} />
  );
};

ImageRel.defaultProps = {
  objectFit: undefined,
  relationship: undefined,
  width: '100%',
  height: undefined,
  rounded: true,
};

ImageRel.propTypes = {
  objectFit: PropTypes.string,
  relationship: PropTypes.object,
  width: PropTypes.string,
  height: PropTypes.string,
  rounded: PropTypes.bool,
};
